import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { ExplorePanelState, ExplorePerformanceDataSelectorsResponse, PerformanceDataSelections } from './models';

const selectExplorePanelState = (state: RootState): ExplorePanelState => state.explorePanel;

export const selectPDSelectors = createSelector(
  [selectExplorePanelState],
  (state: ExplorePanelState) => state ? state.performanceDataSelectors : null
);

export const selectPDVariablesSelectors = createSelector(
  [selectPDSelectors],
  (state:ExplorePerformanceDataSelectorsResponse|null) => state ? {...state.variablesList, ...state.subgroupsList} : null
);

export const selectPDSelectorsLoading = createSelector(
  [selectExplorePanelState],
  (state: ExplorePanelState) => state ? state.perDataSelectorsLoading : null
);

export const selectPDSelectorsLoaded = createSelector(
  [selectExplorePanelState],
  (state: ExplorePanelState) => state ? state.perDataSelectorsLoaded : null
);

export const selectPDSelections = createSelector(
  [selectExplorePanelState],
  (state: ExplorePanelState) => state ? state.performanceDataSelections : null
);

export const selectPDVariables = createSelector(
  [selectPDSelections],
  (state: PerformanceDataSelections|null) => state ? state.variablesSelected : null
);
